export const geofenceService = {
  // Calculate distance between two coordinates using Haversine formula
  calculateDistance(lat1: number, lng1: number, lat2: number, lng2: number): number {
    const R = 6371e3; // Earth's radius in meters
    const φ1 = lat1 * Math.PI / 180;
    const φ2 = lat2 * Math.PI / 180;
    const Δφ = (lat2 - lat1) * Math.PI / 180;
    const Δλ = (lng2 - lng1) * Math.PI / 180;

    const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
              Math.cos(φ1) * Math.cos(φ2) *
              Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c; // Distance in meters
  },

  // Convert meters to miles
  metersToMiles(meters: number): number {
    return meters * 0.000621371;
  },

  // Format distance for display
  formatDistance(meters: number): string {
    const miles = this.metersToMiles(meters);
    if (miles < 0.1) {
      return `${Math.round(meters)} meters`;
    }
    return `${miles.toFixed(1)} miles`;
  },

  // Check if point is inside circular geofence (client-side only for UI)
  isInsideCircle(lat: number, lng: number, centerLat: number, centerLng: number, radius: number): boolean {
    const distance = this.calculateDistance(lat, lng, centerLat, centerLng);
    return distance <= radius;
  },

  // Check if point is inside polygon geofence (client-side only for UI)
  isInsidePolygon(lat: number, lng: number, points: { lat: number; lng: number }[]): boolean {
    let inside = false;
    for (let i = 0, j = points.length - 1; i < points.length; j = i++) {
      const xi = points[i].lat, yi = points[i].lng;
      const xj = points[j].lat, yj = points[j].lng;
      
      const intersect = ((yi > lng) !== (yj > lng))
          && (lat < (xj - xi) * (lng - yi) / (yj - yi) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  }
};
